export const generateUrl = (module, moduleType, action)=>{
    return `/${module}/${moduleType}/${action}`.toLowerCase();
};
